<template>
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 14C15.657 14 17 15.343 17 17C17 18.657 15.657 20 14 20C12.343 20 11 18.657 11 17C11 15.343 12.343 14 14 14ZM4 10C6.21 10 8 11.79 8 14C8 16.21 6.21 18 4 18C1.79 18 0 16.21 0 14C0 11.79 1.79 10 4 10ZM14 16C13.448 16 13 16.448 13 17C13 17.552 13.448 18 14 18C14.552 18 15 17.552 15 17C15 16.448 14.552 16 14 16ZM4 12C2.895 12 2 12.895 2 14C2 15.105 2.895 16 4 16C5.105 16 6 15.105 6 14C6 12.895 5.105 12 4 12ZM12.5 0C15.538 0 18 2.462 18 5.5C18 8.538 15.538 11 12.5 11C9.462 11 7 8.538 7 5.5C7 2.462 9.462 0 12.5 0ZM12.5 2C10.567 2 9 3.567 9 5.5C9 7.433 10.567 9 12.5 9C14.433 9 16 7.433 16 5.5C16 3.567 14.433 2 12.5 2Z" fill="#777777"/>
  </svg>
</template>

<script>
export default {
  name: "Circulos"
}
</script>

<style scoped>

</style>
